import {useGTMDispatch} from './react-gtm-hook/index'

export const useMealDealTracking = () => {
  const sendDataToGTM = useGTMDispatch()
  const sendMealDealData = (mealDealData) => {
    if (!mealDealData) {
      return null
    }

    setTimeout(() => {
      try {
        const {id, name, progress, builderAvailable} = mealDealData
        sendDataToGTM({
          event: 'meal_deal',
          ecommerce: {
            meal_deal_id: id ?? 'Missing Meal Deal identifier',
            meal_deal_name: name ?? 'Missing Meal Deal name',
            meal_deal_progress: !builderAvailable ? 'Unavailable' : progress ?? 'Missing Meal Deal progress',
              }
        })
      } catch (error) {
        console.error('useMealDealTracking error within setTimeout: ' + error.message)
      }
    })
  }
  return sendMealDealData
}